import React, { useEffect, useState } from "react"
import ReactEcharts from "echarts-for-react"
// import Datetime from 'react-datetime';
import DatePicker from "react-datepicker"
import "./style.css"
import API from "../../api/api"
import moment from "moment"

import "react-datepicker/dist/react-datepicker.css"

const Line = ({ chartType }) => {
  const [fromDate, setFromDate] = useState(new Date())
  const [toDate, setToDate] = useState(new Date())
  const [graphData, setGraphData] = useState([])
  const [dateList, setDateList] = useState([])
  const [yAxisValue, setYAxisValue] = useState([])

  const getOption = () => {
    return {
      tooltip: {
        trigger: "axis",
      },
      toolbox: {
        show: false,
        feature: {
          saveAsImage: {},
        },
      },
      grid: {
        zlevel: 0,
        x: 50,
        x2: 50,
        y: 30,
        y2: 30,
        borderWidth: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "rgba(0,0,0,0)",
      },
      xAxis: {
        type: "category",
        data: [...dateList],
        axisLine: {
          lineStyle: {
            color: "#74788d",
          },
        },
      },
      yAxis: {
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#74788d",
          },
        },
      },
      series: [
        {
          data: [...yAxisValue],
          type: "line",
        },
      ],
      color: ["#02a499"],
    }
  }

  const dateToUtc = dateValue => {
    return moment.utc(dateValue).format()
  }

  useEffect(() => {
    let isServiceProvider = false
    if (chartType === "partners") {
      isServiceProvider = true
    }
    const startDate = dateToUtc(fromDate)
    const endDate = dateToUtc(toDate)
    try {
      API.getGraphData({ startDate, endDate, isServiceProvider })
        .then(response => {
          const dateList = response.data.data.map(item => {
            return moment.utc(item.date).local().format("YYYY-MM-DD")
          })

          const yAxisCount = response.data.data.map(item => {
            return item.count
          })
          setDateList(dateList)
          setYAxisValue(yAxisCount)
        })
        .catch(e => {})
    } catch (e) {}
  }, [fromDate, toDate])

  return (
    <React.Fragment>
      {/* <Datetime /> */}
      <div className="d-flex">
        <div style={{ marginRight: "6px" }}>From</div>
        <DatePicker selected={fromDate} onChange={date => setFromDate(date)} />
        <div style={{ marginRight: "6px" }}>To</div>
        <DatePicker selected={toDate} onChange={date => setToDate(date)} />
      </div>
      {dateList?.length > 0 ? (
        <ReactEcharts style={{ height: "350px" }} option={getOption()} />
      ) : (
        <div
          style={{
            minHeight: "350px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          No data
        </div>
      )}
    </React.Fragment>
  )
}
export default Line
